import type {RouteParams} from 'types/routes'
import {MYPAGE_PATHS} from 'consts/paths'
import {ProcedureNew} from 'pages/withAuth/mypage/procedureNew/ProcedureNew'

export const ProcedureNewRoutes: RouteParams[] = [
  {
    key: '/mypage/procedure_new',
    path: MYPAGE_PATHS.PROCEDURE_NEW.INDEX,
    component: ProcedureNew,
    exact: true,
  },
]
